var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"create-payment"}},[_c('payment-form',{attrs:{"payment-info":_vm.paymentInfoForCreate,"submit":_vm.createPayment}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }